import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** ジョブ状態 */
enum JobStatus {
  onStandby = 'ON_STANDBY',
  executing = 'EXECUTING',
  completed = 'COMPLETED',
  stopping = 'STOPPING',
  stop = 'STOP',
  checkError = 'CHECK_ERROR',
  systemError = 'SYSTEM_ERROR',
}

const nameConfig = {
  onStandby: new Map([[Locale.ja, '待機中']]),
  executing: new Map([[Locale.ja, '実行中']]),
  completed: new Map([[Locale.ja, '正常終了']]),
  stopping: new Map([[Locale.ja, '中止中']]),
  stop: new Map([[Locale.ja, '中止']]),
  checkError: new Map([[Locale.ja, 'チェックエラー']]),
  systemError: new Map([[Locale.ja, 'システムエラー']]),
};

const toEnum = rawValueToEnum(JobStatus, JobStatus.onStandby);
const toDisplay = enumToName(JobStatus, nameConfig);

export const jobStatus = {
  enum: JobStatus,
  nameConfig,
  toDisplay,
  toEnum,
};
export type { JobStatus };
